// @oasis-permission-inherits: /ai-edits (studio-edits:view)
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_dash/ai-edits/$operationId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { operationId } = Route.useParams();
  return <Navigate to="/ai-edits/all" search={{ operationIds: operationId }} />;
}
